import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  DEFAULT_IMAGE,
  SITE_NAME,
  getRouteMeta,
  getStructuredData,
} from "../seo/routeMetadata";

const setMeta = (selector, attributeName, attributeValue, content) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attributeName, attributeValue);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]');

  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }

  link.setAttribute("href", href);
};

const setStructuredData = (schema) => {
  const routeScripts = Array.from(
    document.head.querySelectorAll(
      'script#route-structured-data[type="application/ld+json"]',
    ),
  );
  let script = routeScripts[0] || null;

  routeScripts.slice(1).forEach((element) => element.remove());

  if (!schema) {
    script?.remove();
    return;
  }

  if (!script) {
    script = document.createElement("script");
    script.id = "route-structured-data";
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(schema);
};

export const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = getRouteMeta(pathname);
    if (!meta) return;

    document.title = meta.title;
    setMeta('meta[name="description"]', "name", "description", meta.description);
    setMeta('meta[name="robots"]', "name", "robots", meta.robots);
    setMeta('meta[property="og:title"]', "property", "og:title", meta.title);
    setMeta(
      'meta[property="og:description"]',
      "property",
      "og:description",
      meta.description,
    );
    setMeta('meta[property="og:type"]', "property", "og:type", "website");
    setMeta('meta[property="og:url"]', "property", "og:url", meta.canonical);
    setMeta('meta[property="og:image"]', "property", "og:image", DEFAULT_IMAGE);
    setMeta(
      'meta[property="og:site_name"]',
      "property",
      "og:site_name",
      SITE_NAME,
    );
    setMeta(
      'meta[name="twitter:card"]',
      "name",
      "twitter:card",
      "summary_large_image",
    );
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", meta.title);
    setMeta(
      'meta[name="twitter:description"]',
      "name",
      "twitter:description",
      meta.description,
    );
    setMeta(
      'meta[name="twitter:image"]',
      "name",
      "twitter:image",
      DEFAULT_IMAGE,
    );
    setCanonical(meta.canonical);
    setStructuredData(getStructuredData(meta));
  }, [pathname]);

  return null;
};

export default SEO;
